import * as React from 'react';
import { IconProps } from '../types';

const IcMenuCalendar = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M5.5 5.2a.8.8 0 0 0-.8.8v14a.8.8 0 0 0 .8.8h14a.8.8 0 0 0 .8-.8V6a.8.8 0 0 0-.8-.8h-14ZM3.05 6c0-1.767.683-2.45 2.45-2.45h14c1.767 0 2.45.683 2.45 2.45v14c0 1.767-.683 2.45-2.45 2.45h-14c-1.767 0-2.45-.683-2.45-2.45V6Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M16.625 1.5c.621 0 1.125.44 1.125.984v3.282c0 .543-.504.984-1.125.984S15.5 6.31 15.5 5.766V2.484c0-.543.504-.984 1.125-.984ZM8.375 1.5c.621 0 1.125.44 1.125.984v3.282c0 .543-.504.984-1.125.984S7.25 6.31 7.25 5.766V2.484c0-.543.504-.984 1.125-.984ZM3.5 9.75c0-.414.474-.75 1.059-.75H20.44c.585 0 1.059.336 1.059.75s-.474.75-1.059.75H4.56c-.585 0-1.059-.336-1.059-.75Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcMenuCalendar;
